import { PartnerAnalysisGroup3 } from '../../entities/control-tables/partner-analysis-group3';
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { UserInfo } from 'src/app/tools/models/entities/user-info';

export class PartnerAnalysisGroup3Request extends BaseRequest {

    partnerAnalysisGroup3 : PartnerAnalysisGroup3

  constructor(userInfo : UserInfo){
    super(userInfo);
	this.partnerAnalysisGroup3 = new PartnerAnalysisGroup3()
  }
}